'use client';

import { ChevronRight } from '@mui/icons-material';
import { Box, Link, Typography } from '@mui/material';

interface BreadcrumbItem {
  label: string;
  href: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

/**
 * Breadcrumb component for navigation
 */
export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {items.map((item, index) => (
        <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
          {index > 0 && <ChevronRight sx={{ color: '#999999', mx: 1 }} />}
          {index === items.length - 1 ? (
            <Typography
              variant='body2'
              sx={{
                color: '#1A1A1A',
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: 1.5,
              }}
            >
              {item.label}
            </Typography>
          ) : (
            <Link
              href={item.href}
              sx={{
                color: '#999999',
                textDecoration: 'none',
                fontSize: '16px',
                lineHeight: 1.5,
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              {item.label}
            </Link>
          )}
        </Box>
      ))}
    </Box>
  );
}
